import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import firebase from "../firebase";
import { useDispatch, useSelector } from "react-redux";
import SignUp from "../pages/signup";
import SignIn from "../pages/signin";
import ResetPassword from "../pages/reset";
import PrivateRoutes from "./private";
import PaymentView from "../pages/payment";
import Pricing from "../pages/plans"
import actions from "../redux/actions";

export default function App() {
  const { globalLoading, currentUser = {} } = useSelector((state) => ({
    globalLoading: state.globalLoading,
    currentUser: state.currentUser,
  }));
  const dispatch = useDispatch();
  useEffect(() => {
    if (firebase) {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          dispatch({
            type: actions.GET_CURRENT_USER,
            payload: {
              uid: user.email,
            },
          });
        } else {
          // No user is signed in.
          dispatch({
            type: actions.SET_STATE,
            payload: { globalLoading: false },
          });
        }
      });
    }
  }, [firebase]);
  return (
    <>
      {globalLoading ? (
        <Backdrop open={true}>
          <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
        </Backdrop>
      ) : (
        <>
          {currentUser.uid ? (
            <PrivateRoutes uid={currentUser.uid} currentUser={currentUser} />
          ) : (
            <Router>
                <div className="App">
                  <PublicRoutes />
                </div>
            </Router>
          )}
        </>
      )}
    </>
  );
}

function PublicRoutes(props) {
  return (
    <Switch>
      <Route exact path="/signin" component={SignIn} />
      <Route exact path="/signup" component={SignUp} />
      <Route exact path="/reset" component={ResetPassword} />
      <Route exact path="/payment" component={PaymentView} />
      <Route exact path="/plans" component={Pricing} />
      <Route render={() => <Redirect to="/signin" />} />
    </Switch>
  );
}
